import React from "react";
import UpsellButton from "../../shared/UpsellButton";
import { Col, Row } from "react-bootstrap";
import { Gem } from "lucide-react";
import { userEventTracker } from "../../shared/banners/DashboardBanners";
import { useFlow } from "@frigade/react";
import { upgradeRequestFlowId } from "../../../router/FrigadeProvider";

const DashboardUpsellCard = () => {
  const { flow } = useFlow(upgradeRequestFlowId);

  return (
    <div className="pt-4 pb-5 px-5 bg-yellow-0 rounded-2xl">
      <Col>
        <Row className="mb-3">
          <div className="py-0.5 px-2 rounded-3xl font-semibold title-sm d-flex align-items-center bg-premium-gold-gradient">
            <Gem size={10} className="mr-1 mb-0" />
            Premium feature
          </div>
        </Row>
        <Row>
          <div className="h4">Services and support</div>
        </Row>
        <Row>
          <div className="text-md mt-3">
            Get premium support with a dedicated Account Manager and a shared Slack or Teams channel
          </div>
        </Row>
        <Row>
          <div className="text-sm text-gray-40 mt-3">
            Unlock this feature with our premium plans
          </div>
        </Row>
        <Row className="mt-4">
          <UpsellButton
            className="tryPremiumSupport"
            onClick={() => {
              flow?.skip();
              window.open("https://merge.dev/get-in-touch", "_blank");
              userEventTracker({
                event_name_input: "upsell_button_dashboard_support",
                impressions_input: 0,
                dismisses_input: 0,
                clicks_input: 1,
              });
            }}
            buttonContent="Request upgrade"
            buttonColor="gradientGold"
            hasAdvancedHoverState
            id="upsell_button_dashboard_support"
          />
        </Row>
      </Col>
    </div>
  );
};

export default DashboardUpsellCard;
